<template>
  <div class="bg-fff pa-t-16 pa-l-56 pa-b-20 width920px user-message">
    <div class="titles-right font-style">我的证书</div>
    <div class="flex f-wrap">
      <div class="other-img-item">
        <img src="https://duanpianzhou.oss-cn-shanghai.aliyuncs.com/img/de2a2df7-6b08-45f8-87a5-9258d81fd021_81808.png" alt="" srcset="">
        <div class="t-center"><a class="iconfont icon-xiazai" href="https://duanpianzhou.oss-cn-shanghai.aliyuncs.com/img/de2a2df7-6b08-45f8-87a5-9258d81fd021_81808.png" download></a></div>
      </div>
      <div class="other-img-item">
        <img src="https://duanpianzhou.oss-cn-shanghai.aliyuncs.com/img/18ff03ba-d2fb-42c7-97fd-996cf2c446c0_83599.png" alt="" srcset="">
        <div class="t-center"><a class="iconfont icon-xiazai" href="https://duanpianzhou.oss-cn-shanghai.aliyuncs.com/img/18ff03ba-d2fb-42c7-97fd-996cf2c446c0_83599.png" download></a></div>
      </div>
      <div class="other-img-item">
        <img src="https://duanpianzhou.oss-cn-shanghai.aliyuncs.com/img/4d27fc81-2088-442f-8dc3-426f46e6eacb_88813.png" alt="" srcset="">
        <div class="t-center"><a class="iconfont icon-xiazai" href="https://duanpianzhou.oss-cn-shanghai.aliyuncs.com/img/4d27fc81-2088-442f-8dc3-426f46e6eacb_88813.png" download></a></div>
      </div>
      <div class="other-img-item">
        <img src="https://duanpianzhou.oss-cn-shanghai.aliyuncs.com/img/a6b048ab-5d03-431d-a01f-e55c5414545f_82859.png" alt="" srcset="">
        <div class="t-center"><a class="iconfont icon-xiazai" href="https://duanpianzhou.oss-cn-shanghai.aliyuncs.com/img/a6b048ab-5d03-431d-a01f-e55c5414545f_82859.png" download></a></div>
      </div>

      <div class="other-img-item">
        <img src="https://duanpianzhou.oss-cn-shanghai.aliyuncs.com/img/50afa7c1-0621-44fb-985a-a3cecb0757ff_31359.png" alt="" srcset="">
        <div class="t-center"><a class="iconfont icon-xiazai" href="https://duanpianzhou.oss-cn-shanghai.aliyuncs.com/img/50afa7c1-0621-44fb-985a-a3cecb0757ff_31359.png" download></a></div>
      </div>
      <div class="other-img-item">
        <img src="https://duanpianzhou.oss-cn-shanghai.aliyuncs.com/img/286de2a3-a441-4ed4-b145-bd9864915132_39939.png" alt="" srcset="">
        <div class="t-center"><a class="iconfont icon-xiazai" href="https://duanpianzhou.oss-cn-shanghai.aliyuncs.com/img/286de2a3-a441-4ed4-b145-bd9864915132_39939.png" download></a></div>
      </div>

      <div class="other-img-item">
        <img src="https://duanpianzhou.oss-cn-shanghai.aliyuncs.com/img/b5f9bbe5-215d-4558-afbf-2f5666a9385c_38151.png" alt="" srcset="">
        <div class="t-center"><a class="iconfont icon-xiazai" href="https://duanpianzhou.oss-cn-shanghai.aliyuncs.com/img/b5f9bbe5-215d-4558-afbf-2f5666a9385c_38151.png" download></a></div>
      </div>
      <div class="other-img-item">
        <img src="https://duanpianzhou.oss-cn-shanghai.aliyuncs.com/img/1bd2bf9f-adb2-4b9a-a5f2-8a4b2511d90c_84458.png" alt="" srcset="">
        <div class="t-center"><a class="iconfont icon-xiazai" href="https://duanpianzhou.oss-cn-shanghai.aliyuncs.com/img/1bd2bf9f-adb2-4b9a-a5f2-8a4b2511d90c_84458.png" download></a></div>
      </div>

    </div>
    <div class="flex f-wrap ma-t-20">
      <div
        class="cert-box"
        v-for="(item, index) in dataList"
        :key="index"
      >
        <img  :src="item.CertPath" alt="" srcset=""/>
        <div class="t-center"><a class="iconfont icon-xiazai"  :href="item.CertPath" download></a></div>
      </div>
      <div v-if="dataList.length == 0" class="width100">
        <div class="t-center ma-t-40">
          <img src="../img/empty.png" alt="" srcset="" width="200" />
          <div class="c-999">暂无数据</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
var _this;
import { getMycertificate } from "../api";
export default {
  name: "mycertificate",
  data() {
    return {
      dataList: [],
    };
  },
  mounted() {
    _this = this;
    _this.loadDataList();
  },
  methods: {
    //下载证书图片
    downCert(url) {
      let a = document.createElement("a"); // 生成一个a元素
      let event = new MouseEvent("click"); // 创建一个单击事件
      a.href = url; // 将生成的URL设置为a.href属性
      a.dispatchEvent(event); // 触发a的单击事件
    },
    loadDataList() {
      getMycertificate().then((res) => {
        this.dataList = res.data.Data;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
$certHeight: 848px;

.btn-downcert {
  display: inline-block;
  text-align: center;
  cursor: pointer;
  background: #fa004c;
  color: #fff;
  padding: 5px 10px;
  font-size: 12px;
}
.fon-7 {
  font-size: 7px;
}
.c-logo {
  color: #fa004c;
}
.cert-box {
  width: 30%;
  margin-right: 3%;
  margin-bottom: 20px;
  img{
    width: 100%;
  }
}

.titles-right:before {
  content: "|";
  display: inline-block;
  width: 4px;
  height: 19px;
  background: #fb004d;
  color: #fb004d;
  border-radius: 2px;
  margin-right: 8px;
}
.width920px {
  width: 920px;
}
.font-style {
  font-size: 14px;
  font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
  font-weight: bold;
}
.tab-active {
  border-bottom: 2px solid #fb004d;
}

.img_certificate {
  width: 180px;
  height: 230px;
}
.other-img-item{
  width: 180px;
  margin-right: 20px;
  img{
    width: 100%;
    height: 100px;
    object-fit: contain;
    background: #ddd;
  }
}
</style>